 $(document).ready(function(){
            $('.review-slider').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                arrows: false,
                dots: false,
                speed: 300,
                centerPadding: '2px',
                infinite: true,
                autoplaySpeed: 5000,
                autoplay: true,
                responsive: [
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                ],
            });
        });
document.addEventListener("DOMContentLoaded", function() {
    var daysFromNow = 1; // One day ahead
    var currentDate = new Date();
    var estimatedDate = new Date(currentDate.setDate(currentDate.getDate() + daysFromNow));
    var options = { weekday: 'short', month: 'long', day: 'numeric' };
    var displayDate = estimatedDate.toLocaleDateString('en-US', options); // English locale

    document.getElementById('estimated-delivery').textContent = displayDate;
});

document.addEventListener('DOMContentLoaded', function () {
   var swiper = new Swiper('.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      500: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      1000: {
        slidesPerView: 2,
        spaceBetween: 0
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 0
      },
      1500: {
        slidesPerView: 3,
        spaceBetween: 0
      },
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    loop: true,
    centerMode: false,
  });
    });

